var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangeStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6285 3.85478C12.38 1.89675 10.1997 0.675713 7.8355 0.675713C6.00159 0.675713 4.27745 1.38989 2.98065 2.68663C1.6839 3.98343 0.969727 5.70757 0.969727 7.54149C0.969727 9.3754 1.6839 11.0995 2.98065 12.3963C4.27745 13.6931 6.00159 14.4073 7.8355 14.4073C7.84003 14.4073 7.8444 14.4067 7.84891 14.4066C7.85342 14.4067 7.85779 14.4073 7.86232 14.4073C8.05563 14.4073 8.25085 14.3991 8.44261 14.3831C8.73781 14.3583 8.95709 14.099 8.93239 13.8038C8.90763 13.5086 8.64864 13.2892 8.35309 13.314C8.19099 13.3276 8.02589 13.3345 7.86232 13.3345C7.85779 13.3345 7.85342 13.335 7.84891 13.3352C7.8444 13.335 7.84003 13.3345 7.8355 13.3345C4.64123 13.3345 2.0425 10.7358 2.0425 7.54149C2.0425 4.34721 4.64123 1.74849 7.8355 1.74849C9.89411 1.74849 11.7875 2.84575 12.8222 4.59135L12.8184 4.58495L13.6285 3.85478Z",
    fill: "#F0B747",
    stroke: "#F0B747",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4749 5.02658L13.7776 5.44321C14.1161 5.48592 14.4323 5.2406 14.475 4.90208L14.8916 1.59939C14.9343 1.26087 14.689 0.944727 14.3505 0.902023C14.0119 0.859318 13.6958 1.10463 13.6531 1.44316L13.3146 4.12659L10.6312 3.78808C10.2926 3.74537 9.97649 3.99069 9.93379 4.32921C9.89108 4.66774 10.1364 4.98388 10.4749 5.02658Z",
    fill: "#F0B747"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.46973,
    y: 4.90729,
    width: 6,
    height: 6,
    rx: 3,
    fill: "#F0B747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeStatus);
export default __webpack_public_path__ + "static/media/changeStatus.ea5676c2aa06dd6063dff7241ae419b2.svg";
export { ForwardRef as ReactComponent };